import { useContext } from "react";
import { A11yChild } from "../../../../../a11y";
import { Text } from "../../../../../text";
import { getFileExtension, getFileName } from "../../../../utils";
import { FileItemContext } from "../../providers";
import styles from "./styles.module.scss";

export const FileInfo = () => {
  const {
    a11yChildCurrentIndex,
    downloadButtonIndex = 0,
    handleFileDownload,
    a11yChildRefWithIndex,
    file = { name: "" },
    hasError,
    dataTestId,
    hasChildren,
  } = useContext(FileItemContext);

  const { name: nameWithExtension } = file;

  const errors = "errors" in file ? file.errors : undefined;

  const name = getFileName(String(nameWithExtension));
  const extension = getFileExtension(String(nameWithExtension));

  const restFullNameTextProps = {
    ...(hasChildren && { htmlTitle: nameWithExtension }),
  };

  return (
    <A11yChild
      hasA11yFocus={a11yChildCurrentIndex === downloadButtonIndex}
      a11yChildRef={a11yChildRefWithIndex?.(downloadButtonIndex)}
    >
      <button className={styles["file-info"]} onClick={handleFileDownload}>
        <Text className={styles["full-name"]} {...restFullNameTextProps}>
          <span className={styles["file-name"]}>{name}</span>
          {extension}
        </Text>
        {hasError && (
          <div
            className={styles["file-errors"]}
            data-test-id={`${dataTestId}-error-message`}
          >
            {errors?.map(({ message }) => (
              <span className={styles["file-error"]}>{message}</span>
            ))}
          </div>
        )}
      </button>
    </A11yChild>
  );
};
